let findMatchDevice = (deviceList, device, pairKey, secondPairKey) => {
  return deviceList.findIndex(e => {
    return e[pairKey] === device[pairKey] || e[secondPairKey] === device[secondPairKey];
  });
};

const ble = {
  namespaced: true,
  state: {
    connectedDevices: [],
    //連線操作完成 尚未連線成功前 的數量  (轉圈的數量)
    preConnectionNumber: 0,
    //是否關閉 Ble元件
    isBleCompOpen: false
  },
  mutations: {
    addConnectedDevice(state, device) {
      state.connectedDevices.push(device);
    },
    setConnectedDevice(state, { device, key, val }) {
      let index = findMatchDevice(state.connectedDevices, device, "name");
      state.connectedDevices[index][key] = val;
    },
    removeConnectedDevice(state, device) {
      let index = findMatchDevice(state.connectedDevices, device, "name", "mac");
      state.connectedDevices.splice(index, 1);
    },
    //isOpen is Bollean
    toggleBleComp(state, isOpen) {
      state.isBleCompOpen = isOpen;
    },
    preConnectionNumberAdd(state, count) {
      if (state.preConnectionNumber === 4) return;
      state.preConnectionNumber += count;
    },
    preConnectionNumberMinus(state, count) {
      if (state.preConnectionNumber === 0) return;
      state.preConnectionNumber -= count;
    },
    setConnectionNumber(state, number) {
      state.preConnectionNumber = number;
    }
  },
  actions: {},
  getters: {}
};

export default ble;
